import { t } from "@/utils/i18n";

export function formatTimestampToLocalTime(unixTimestamp: number, options?: { format: 'date' | 'time' | 'both', noYear?: boolean, humanAliases?: boolean }): string {
    const date = new Date(unixTimestamp * 1000);
    const localeStringOptions: Intl.DateTimeFormatOptions = {};

    switch (options?.format) {
        case 'date':
            localeStringOptions.year = 'numeric';
            localeStringOptions.month = 'numeric';
            localeStringOptions.day = 'numeric';
            break;
        case 'time':
            localeStringOptions.hour = 'numeric';
            localeStringOptions.minute = 'numeric';
            localeStringOptions.second = 'numeric';
            break;
        case 'both':
        default:
            localeStringOptions.year = 'numeric';
            localeStringOptions.month = 'numeric';
            localeStringOptions.day = 'numeric';
            localeStringOptions.hour = 'numeric';
            localeStringOptions.minute = 'numeric';
            localeStringOptions.second = 'numeric';
            break;
    }



    let d = date.toLocaleString(undefined, localeStringOptions);
    if (options?.noYear) {
        d = d.replace(/\/\d{4}/, '');
    }
    if (d.includes(':00')) d = d.replace(/:\d{2}$/, '');

    if (options?.humanAliases != false) {
        let todayDateString = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' });
        let tomorrowDateString = new Date(Date.now() + 24 * 60 * 60 * 1000).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' });
        let yesterdayDateString = new Date(Date.now() - 24 * 60 * 60 * 1000).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' });
        if (d.includes(todayDateString)) {
            d = d.replace(todayDateString, t('datetime.datetime_1'));
        }
        if (d.includes(tomorrowDateString)) {
            d = d.replace(tomorrowDateString, t('datetime.datetime_3'));
        }
        if (d.includes(yesterdayDateString)) {
            d = d.replace(yesterdayDateString, t('datetime.datetime_2'));
        }
    }

    return d;
}

export function formatTimestampToDayMonth(timestamp: number, year: boolean = false): string {
    const date = new Date(timestamp * 1000);
    const day = date.getDate().toString().padStart(2, '0');
    const months = [
        t('finder_player.finder_player_30'),
        t('finder_player.finder_player_31'),
        t('finder_player.finder_player_32'),
        t('finder_player.finder_player_33'),
        t('finder_player.finder_player_34'),
        t('finder_player.finder_player_35'),
        t('finder_player.finder_player_36'),
        t('finder_player.finder_player_37'),
        t('finder_player.finder_player_38'),
        t('finder_player.finder_player_39'),
        t('finder_player.finder_player_40'),
        t('finder_player.finder_player_41')
    ];
    const month = months[date.getMonth()];
    if (year) {
        const shortYear = date.getFullYear().toString().slice(-2);
        return `${day}/${month}/${shortYear}`;
    }
    return `${day}/${month}`;
}

export function getTimezoneOffset(): number {
    return (new Date()).getTimezoneOffset();
}

export function localTimeToUnixTimestamp(dateString: string | Date): number {
    // give me a date string in the format of 'YYYY-MM-DD'
    // and I will give you the unix timestamp in utc (seconds)
    const date = typeof dateString == 'string' ? new Date(dateString) : dateString;
    return Math.floor(date.getTime() / 1000) + (date.getTimezoneOffset() * 60);
}

export function getDeltaDaysFromNow(unixTimestamp: number): number {
    const now = Math.floor(Date.now() / 1000);
    const delta = unixTimestamp + now;
    return delta
}

export function newDateWithAddedSeconds(date: Date, seconds: number): Date {
    return new Date(date.getTime() + seconds * 1000);
}

export function countdownSecondsToTimestamp(unixTimestamp: number): number {
    const now = Math.floor(Date.now() / 1000);
    return Math.max(0, unixTimestamp - now);
}